<svg [climbIcon]="icons.plusCircleFilled"></svg>
